module.exports = __webpack_public_path__ + "img/sensetive-land-none.98130719.svg";